import { usePostHttp } from "../../http.hook";

interface IBody {
  gst: string;
}

interface IResponse {
  gstin: string;
  lgnm: string;
  stcd: string;
  stnm: string;
  tradeNam: string;
}

export function useVerifyGstAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/vendors/:vendorId/gst",
  });
}
